module.exports = __webpack_public_path__ + "static/architecture-a3b2d7403676e4d15f230ea0db6a7d59.png";